/**
 * SearchBar - barre de recherche reutilisable pour les listes.
 *
 * Props :
 *  - value             : string controle
 *  - onChange(string)  : callback
 *  - placeholder       : texte indicatif
 *  - resultsCount      : nombre de resultats filtres (null = pas affiche)
 *  - totalCount        : nombre total (affiche "N resultats sur M")
 *  - className         : classes additionnelles
 *  - testid            : data-testid prefix
 */
import React from 'react';

const SearchBar = ({
  value,
  onChange,
  placeholder = 'Rechercher...',
  resultsCount = null,
  totalCount = null,
  className = '',
  testid = 'search-bar',
}) => {
  const showCount = resultsCount !== null && totalCount !== null && value && value.trim().length > 0;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid={`${testid}-wrapper`}>
      <div className="relative flex-1 max-w-md">
        <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-4.35-4.35m1.85-5.65a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z" />
        </svg>
        <input
          type="text"
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full pl-9 pr-9 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#008A8D] focus:outline-none focus:ring-1 focus:ring-[#008A8D]"
          data-testid={`${testid}-input`}
        />
        {value && (
          <button
            onClick={() => onChange('')}
            type="button"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 w-5 h-5 rounded-full flex items-center justify-center hover:bg-gray-100"
            title="Effacer"
            data-testid={`${testid}-clear`}>
            &times;
          </button>
        )}
      </div>
      {showCount && (
        <span className="text-xs text-gray-500" data-testid={`${testid}-count`}>
          {resultsCount} resultat{resultsCount > 1 ? 's' : ''} sur {totalCount}
        </span>
      )}
    </div>
  );
};

/**
 * matchesSearch - util pour filtrer une liste sur plusieurs champs.
 * @param {Object} item
 * @param {string} query
 * @param {string[]} fields - chemins (supports dot-notation)
 */
export const matchesSearch = (item, query, fields) => {
  if (!query) return true;
  const q = query.trim().toLowerCase();
  if (!q) return true;
  for (const path of fields) {
    let v = item;
    for (const part of path.split('.')) {
      if (v == null) break;
      v = v[part];
    }
    if (v == null) continue;
    if (String(v).toLowerCase().includes(q)) return true;
  }
  return false;
};

export default SearchBar;
